import DuelPuzzleInfo from './DuelPuzzleInfo';
export default DuelPuzzleInfo;